module.exports = __webpack_public_path__ + "assets/vip-default-banner.png";